module.exports = __webpack_public_path__ + "img/top_three@3x.bbd88623.png";